import { useEffect, useMemo, useContext } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Footer from './Footer';
import Header from './Header';
import Sidebar from './Sidebar';
import HorizontalBar from './HorizontalBar';
import MainContentStyled from './MainContentStyled';
import Loader from 'ui-component/Loader';
import ImpersonationBanner from 'ui-component/ImpersonationBanner';
import JWTContext from 'contexts/JWTContext';

import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));

  const {
    state: { borderRadius, container, miniDrawer, menuOrientation }
  } = useConfig();
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  useEffect(() => {
    handlerDrawerOpen(!miniDrawer);
  }, [miniDrawer]);

  useEffect(() => {
    downMD && handlerDrawerOpen(false);
  }, [downMD]);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  // horizontal menu-list bar : drawer
  const menu = useMemo(() => (isHorizontal ? <HorizontalBar /> : <Sidebar />), [isHorizontal]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* header */}
      <AppBar enableColorOnDark position="static" color="inherit" elevation={0} sx={{ bgcolor: 'background.default', zIndex: 1201 }}>
        <Toolbar sx={{ p: 1 }}>
          <Header />
        </Toolbar>
      </AppBar>

      {/* impersonation banner */}
      <ImpersonationBanner />

      {/* menu / drawer */}
      {/* menu / drawer - HIDDEN per user request (moved to gear icon) */}
      {/* {menu} */}

      {/* main content */}
      <MainContentStyled {...{ borderRadius, menuOrientation, open: drawerOpen }} sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            p: 1,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto'
          }}
        >
          <Outlet />
          {/* <Footer /> */}
        </Container>
      </MainContentStyled>
    </Box>
  );
}
